import ApiService, {callCustomMethodAsync}  from '../service/ApiService';

let moduleApi = {};
let moduleName = "salary";

moduleApi.create = async (dataForm) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.ImportSalary = (data) => {
  let api = {
    module: moduleName,
    type: "ImportSalary",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.CheckImportSalary = (data) => {
  let api = {
    module: moduleName,
    type: "CheckImportSalary",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.GetEmployeeSalaries = (data) => {
  let api = {
    module: moduleName,
    type: "GetEmployeeSalaries",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.GetCompanyPayroll = (data) => {
  let api = {
    module: moduleName,
    type: "GetCompanyPayroll",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.UpdateCompanyPayrollField = (data) => {
  let api = {
    module: moduleName,
    type: "UpdateCompanyPayrollField",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.SealCompanyPayroll = (data) => {
  let api = {
    module: moduleName,
    type: "SealCompanyPayroll",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.SaveFormulaConfigHistory = (data) => {
  let api = {
    module: moduleName,
    type: "SaveFormulaConfigHistory",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.GetFormulaConfigHistory = (data = {}) => {
  let api = {
    module: moduleName,
    type: "GetFormulaConfigHistory",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.salaryStatistics = async (data,loading) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "salaryStatistics",
    value: data,
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
